<template>
  <form novalidate @submit.prevent="onSubmit">
    <slot/>
  </form>
</template>

<script>
import dot from 'dot-object';

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  provide() {
    const form = {};

    Object.defineProperty(form, 'pristine', {
      enumerable: true,
      get: () => this.pristine,
    });

    Object.defineProperty(form, 'loading', {
      enumerable: true,
      get: () => this.loading,
    });

    return { form };
  },
  data: () => ({
    pristine: true,
  }),
  methods: {
    error(errors, scroll = true) {
      errors.forEach(item => {
        let name;

        if (typeof item === 'string') {
          name = item;
        } else if (typeof item === 'object') {
          ({ name } = item);
        } else {
          return;
        }

        const el = this.$children.find(child => child.name === name);

        if (el && typeof el.invalidate === 'function') {
          if (typeof item === 'object') {
            el.invalidate(item.status);
          } else {
            el.invalidate();
          }
        }

        if (el && typeof el.touch === 'function') {
          el.touch();
        }
      });

      if (scroll) {
        const [first] = errors;
        let elementName;

        if (typeof first === 'object') {
          elementName = first.name;
        } else {
          elementName = first;
        }

        this.$scrollTo(this.$children.find(child => child.name === elementName).$el);
      }
    },

    collect() {
      return this.$children
        .filter(({ name, model }) => name && model !== undefined)
        .map(({ name, model, isValid, errorStatus }) => [name, model, isValid, errorStatus]);
    },

    captureBehaviour() {
      return this.$children
        .filter(({ name, behaviour }) => name && behaviour)
        .reduce((acc, { name, behaviour }) => {
          acc[name] = { ...behaviour };
          return acc;
        }, {});
    },

    onSubmit() {
      this.pristine = false;

      if (!this.loading) {
        const data = this.collect();
        const errors = data.filter(([, , isValid]) => !isValid).map(([name, , , status]) => ({
          name,
          status,
        }));

        if (errors.length) {
          this.error(errors);
        } else {
          const descriptor = data.reduce((acc, [name, model]) => {
            acc[name] = model;
            return acc;
          }, {});

          this.$emit('submit', dot.object(descriptor), {
            behaviour: this.captureBehaviour(),
          });
        }
      }
    },
  },
};
</script>
